import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 顧客情報一覧
export async function getContractCustomerInfos(id: string) {
  try {
    const path = "contractCustomerInfos";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [], option_data: [] };
    }
    const option_data: {
      [key: string]: string | number;
    }[] = response.data.option_data;
    return { sudDatas: response.data.fetch_data, option_data };
  } catch (error) {
    return { sudDatas: [], option_data: [] };
    // logout();
  }
}

// 顧客情報ダイレクト編集
export async function putContractCustomerInfo(editData: EditDataDifine) {
  try {
    const path = "contractCustomerInfo";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
      editPhoneNumber: editData.editPhoneNumber,
      editName: editData.editName,
      tel_flg: editData.tel_flg,
      name_flg: editData.name_flg,
      half_width_number_flg: editData.half_width_number_flg,
    };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}
